import { UserCouponWithCoupon, UserCouponWithCouponAndUsesCount } from './coupon';
import { RoutineDetail } from './Fisiofit/routine';
import { ItemDisplay } from './responses';
import { ExternalUserSignedDocument } from './signedDocument';
import { UserShort } from './user';

export enum EXTERNAL_USER_STATUSES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum EXTERNAL_USER_GENDERS {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export enum USER_ROUTINE_EVENTS {
  NEXT_ROUTINE = 'next-routine',
  CURRENT_ROUTINE = 'current-routine',
  CURRENT_ROUTINE_NOT_STARTED = 'current-routine-not-started',
  PAST_ROUTINE = 'past-routine',
  EXPIRED_ROUTINE = 'expired-routine',
  UPDATE = 'update',
}

export enum USER_CURRENT_ROUTINE_STATUS {
  NOT_STARTED = 'not-started',
  IN_PROGRESS = 'in-progress',
  EXPIRED = 'expired',
  NO_ROUTINE = 'no-routine',
  ENDING_SOON = 'ending-soon',
}

interface ExternalUserTableCurrentRoutine {
  id?: string;
  status: USER_CURRENT_ROUTINE_STATUS;
}

export interface ExternalUserShort {
  id: string;
  name: string;
  surnames: string;
  email?: string;
  avatarUrl?: string;
  phone?: string;
  attendance?: boolean;
  supervisor?: UserShort;
  bookedFromApp?: boolean;
  userCouponIds?: string[];
  userCouponsHaveUsesRemaining?: boolean;
  isGymUser?: boolean;
  hasOngoingInjury?: boolean;
}

export interface ExternalUserTableEntry {
  id: string;
  name: string;
  surnames: string;
  fullName?: string;
  joinedDate: string;
  registrationDate?: string;
  createdAt: string; // Fecha de creación del usuario
  status: EXTERNAL_USER_STATUSES;
  avatarUrl?: string;
  userCoupons?: UserCouponWithCoupon[];
  latestReservationDate?: string;
  daysSinceLastVisit?: number | null;
  branch: ItemDisplay;
  pendingInvitation?: boolean;
  isAppUser?: boolean;
  supervisor?: UserShort;
  currentRoutine?: ExternalUserTableCurrentRoutine;
  routineStatus?: USER_CURRENT_ROUTINE_STATUS;
  phone?: string;
  email?: string;
  isGymUser?: boolean;
  reactivationDate?: string; // Fecha de reactivación si existe
}

export interface UserRoutineHistory {
  date: string;
  duration?: number;
  eventType: USER_ROUTINE_EVENTS;
  routineId: string;
  fieldsUpdated?: string[];
}

export interface ExternalUser {
  id: string;
  name: string;
  surnames: string;
  email?: string;

  createdAt: string;
  status: EXTERNAL_USER_STATUSES;
  deactivationDate?: string;
  reactivationDate?: string;

  dateOfBirth?: string;
  gender?: EXTERNAL_USER_GENDERS;
  phone?: string;
  avatarUrl?: string;
  latestReservationDate?: string;
  age?: number;
  nationalId?: string;
  profession?: string;
  address?: string;

  pendingInvitation?: boolean;
  isAppUser?: boolean;

  currentRoutine?: RoutineDetail;

  signedDocuments?: ExternalUserSignedDocument[];

  branchId: string;
  organizationId: string;
  userCoupons?: UserCouponWithCoupon[];

  //Fisiofit fields
  supervisor?: UserShort;
  diagnostic?: string;
  objective?: string;
  isGymUser?: boolean;
  hasOngoingInjury?: boolean;
}

export interface ExternalUserWithCoupons extends ExternalUser {
  userCoupons?: UserCouponWithCouponAndUsesCount[];
}
